import { useLazyQuery, gql } from "@apollo/client"
import { Query } from "@oysterhr/schema"

const COUNTRY_DATA_QUERY = gql`
  query BenefitsSharedCountryOffering($countryCode: String!) {
    countryIntelligence(countryCode: $countryCode) {
      countryBenefits(perPage: 50) {
        collection {
          benefit
          comment
          tier
        }
      }
    }
  }
`

export const useBrainCountryBenefitsOffering = (params: { countryCode?: string }) => {
  return useLazyQuery<Pick<Query, "countryIntelligence">>(COUNTRY_DATA_QUERY, {
    variables: params,
  })
}
